<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('goods_spec_label_orderGoodsSpecNo') || '产品规格编号'"
          >
            <el-input
              v-model="formData.orderGoodsSpecNo"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '系统自动生成'
              "
              disabled
            >
            </el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="16">
          <el-form-item
            :label="$l('goods_spec_label_identifyGoodsName') || '识别名称'"
          >
            <el-input
              clearable
              v-model="formData.identifyGoodsName"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '系统自动生成'
              "
              disabled
            >
            </el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="16">
          <el-form-item
            :label="
              $l('goods_spec_label_identifyGoodsSpecNo') || '产品规格识别编号'
            "
          >
            <identify-input
              size="small"
              :disabled="disabled"
              :identifyNo.sync="formData.identifyGoodsSpecNo"
              :identifyJson.sync="formData.identifyGoodsSpeJson"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('goods_spec_label_orderGoodsSpecName') || '产品规格名称'"
            prop="orderGoodsSpecName"
          >
            <el-input
              clearable
              v-model="formData.orderGoodsSpecName"
              :placeholder="
                $l('tips_goods_spec_label_orderGoodsSpecName') ||
                  '请输入产品规格名称'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('goods_spec_label_englishSize') || '英文尺寸'"
          >
            <dict-select
              clearable
              :placeholder="
                $l('tips_goods_spec_label_englishSize') || '请选择英文尺寸'
              "
              v-model="formData.englishSize"
              filterable
              disabled
              url="/digitalCenter/common/dict/biz"
              :body="englishSizeDictParams"
              :selectedLabel.sync="formData.v_englishSize"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('goods_spec_label_spec') || '产品规格'"
            prop="spec"
          >
            <el-input
              clearable
              v-model="formData.spec"
              :placeholder="
                $l('tips_goods_spec_label_spec') || '请输入产品规格'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('goods_spec_label_specUnit') || '规格单位'"
            prop="specUnit"
          >
            <dict-select
              clearable
              :placeholder="
                $l('tips_goods_spec_label_specUnit') || '请选择规格单位'
              "
              v-model="formData.specUnit"
              filterable
              url="/digitalCenter/common/dict/biz"
              :body="specUnitDictParams"
              :selectedLabel.sync="formData.v_specUnit"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('goods_spec_label_inGroupQty') || '规格数量'"
            prop="inGroupQty"
          >
            <el-input-number
              v-model="formData.inGroupQty"
              :placeholder="$l('tips_goods_spec_label_qty') || '请输入数量'"
              controls-position="right"
              style="width:100%"
              :max="100"
              :min="1"
              :step-strictly="true"
              :step="1"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('goods_spec_label_technologyDesc') || '工艺要求说明'"
            prop="technologyDesc"
          >
            <el-input
              clearable
              type="textarea"
              :rows="2"
              v-model="formData.technologyDesc"
              :placeholder="
                $l('tips_goods_spec_label_technologyDesc') ||
                  '请输入工艺要求说明'
              "
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item
            :label="$l('goods_spec_label_materialDesc') || '面料说明'"
          >
            <el-input
              readonly
              type="textarea"
              :rows="3"
              v-model="formData.materialDesc"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('goods_spec_label_accessoriesDesc') || '辅料说明'"
            prop="accessoriesDesc"
          >
            <el-input
              readonly
              type="textarea"
              :rows="3"
              v-model="formData.accessoriesDesc"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('goods_spec_label_smallPackageDesc') || '小包装说明'"
          >
            <el-input
              readonly
              type="textarea"
              :rows="2"
              v-model="formData.smallPackageDesc"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('goods_spec_label_innerPackageDesc') || '内包装说明'"
          >
            <el-input
              readonly
              type="textarea"
              :rows="2"
              v-model="formData.innerPackageDesc"
            >
            </el-input>
          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {},
  props: {
    disabled: Boolean,
    orderGoodsCode: { type: String, default: '' },
    orderGoodsSpecCode: { type: String, default: '' },
    form: { type: Object, default: () => {} },
    type: { type: String, default: '' }
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      rules: {
        orderGoodsSpecName: [
          {
            required: true,
            message:
              this.$l('tips_goods_spec_label_orderGoodsSpecName') ||
              '请输入产品规格名称',
            trigger: 'blur'
          }
        ],
        spec: [
          {
            required: true,
            message: this.$l('tips_goods_spec_label_spec') || '请输入产品规格',
            trigger: 'blur'
          }
        ],
        specUnit: [
          {
            required: true,
            message:
              this.$l('tips_goods_spec_label_specUnit') || '请选择规格单位',
            trigger: 'blur'
          }
        ],
        inGroupQty: [
          {
            required: true,
            message: this.$l('tips_goods_spec_label_qty') || '请输入数量',
            trigger: 'blur'
          }
        ],
        technologyDesc: [
          {
            required: true,
            message: this.$l('tips_goods_spec_label_technologyDesc') || '请输入工艺要求说明',
            trigger: 'blur'
          }
        ],
      },
      englishSizeDictParams: { dictType: 'englishSize' },
      specUnitDictParams: { dictType: 'specUnit' }
    }
  },
  watch: {
    form: {
      handler() {
        this.getData()
      },
      immediate: true
    }
  },
  methods: {
    getData() {
      if (!this.orderGoodsSpecCode) return
      this.$api
        .orderGoodsSpecDetailApi({
          orderGoodsSpecCode: this.orderGoodsSpecCode
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      const parms = {
        ...this.formData,
        orderGoodsCode: this.orderGoodsCode,
        orderGoodsSpecCode: this.orderGoodsSpecCode
      }
      this.loadingOpen()
      this.$api
        .orderGoodsSpecSaveApi(parms)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success'
            })
            this.$emit('close')
            this.$emit('reload')
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    }
  }
}
</script>
